import {Component, OnInit} from '@angular/core';
import {ErrorStateMatcher} from '@angular/material/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-lab-loja2-page',
  templateUrl: './lab-loja2-page.component.html',
  styleUrls: [ './lab-loja2-page.component.scss' ]
})
export class LabLoja2PageComponent implements OnInit {

  public members: any = [];
  public products: any = [];
  public salesForm: FormGroup;
  public dataPack: any = null;
  public messageError: any = null;

  constructor (
    private fb: FormBuilder,
  ) {
    this.getDataPack()
  }

  ngOnInit () {
  }

  getDataPack () {
    this.dataPack = JSON.parse(sessionStorage.getItem("dataPack"));
    console.log("this.dataPack.events[0].ticket_by_topic: " + this.dataPack.events[0].ticket_by_topic);
  }


}
